import FingerprintJS from "@fingerprintjs/fingerprintjs";

/**
 * Returns a persistent device ID for the current browser/device.
 * Checks localStorage first before generating.
 */
export async function getDeviceId() {
  // Check localStorage
  let storedId = localStorage.getItem("deviceId");
  if (storedId) {
    return storedId;
  }

  // Generate new ID
  const fp = await FingerprintJS.load();
  const result = await fp.get();

  // Store it for future use
  localStorage.setItem("deviceId", result.visitorId);

  return result.visitorId;
}
